import GatedPersonalInfoModule from './GatedPersonalInfoModule';

export default GatedPersonalInfoModule;
